export default __webpack_public_path__ + "static/media/calender_icon.71987fe7.svg";